<div class="searchdiv">
  <div class="headerdiv">
    <table aria-describedby="dashboardData">
      <thead>
        <tr>
          <th scope="col"></th>
        </tr>
      </thead>
      <tr>
        <td>
          <h1>Dashboard</h1>
        </td>
      
        <td>
          <h4 style="margin-left: 20px;margin-top: 9px;">
            <label style="margin-right: 9px;"> Accrual</label>
            <input type="radio" value="A" name="type" checked (click)="selectTypeOfRedemption('A')" />
          </h4>
        </td>
        <td *ngIf="typeOfRedemption == 'A'">
          <h4 style="margin-left: 20px;margin-top: 9px;">
            <ng-multiselect-dropdown-angular7 placeholder="Select the Accural Type" [settings]="dropdownSettings" [data]="accrualTypes"
              [(ngModel)]="selectedAccuralType" (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event, true)" (onDeSelectAll)="onSelectAll($event, true)" (onDeSelect)="onItemSelect($event)">
            </ng-multiselect-dropdown-angular7>
          </h4>
        </td>
        <td>
          <h4 style="margin-left: 20px;margin-top: 9px;">
            <label style="margin-right: 9px;"> Accrual Affiliate</label>
            <input type="radio" value="AAF" name="type" (click)="selectTypeOfRedemption('AAF')" />
          </h4>
        </td>
        <td *ngIf="typeOfRedemption == 'AAF'">
          <h4 style="margin-left: 20px;margin-top: 9px;">
            <ng-multiselect-dropdown-angular7 placeholder="Select the Partner" [settings]="dropdownSettings"
              [data]="affPartners" [(ngModel)]="selectedAffPartner" (onSelect)="onItemSelect($event)"
              (onSelectAll)="onSelectAll($event)" (onDeSelectAll)="onSelectAll($event)"
              (onDeSelect)="onItemSelect($event)">
            </ng-multiselect-dropdown-angular7>
          </h4>
        </td>
        <td>
          <h4 style="margin-left: 20px;margin-top: 9px;">
            <label style="margin-right: 9px;"> Redemption</label>
            <input type="radio" value="R" name="type"  (click)="selectTypeOfRedemption('R')" />
          </h4>
        </td>
      </tr>
    </table>

    <div class="sdiv" style="margin-top: 20px;margin-right: 10px;"></div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-div">
          <div class="row">
            <div class="m-portlet">
              <div>
                <div>
                  <div class="reportstatusdash">
                    <div class="pai" style="display: block">
                      <canvas baseChart [data]="doughnutChartData" [labels]="doughnutChartLabels"
                        [chartType]="doughnutChartType"></canvas>
                    </div>
                  </div>
                  <div class="rdash">
                    <table aria-describedby="dashboardDetails">
                      <thead>
                        <tr>
                          <th scope="col"></th>
                        </tr>
                      </thead>
                      <ng-container *ngIf="typeOfRedemption == 'R'">
                        <tr>
                          <td style="width: 40%">
                            <div class="intd1 fc">Booking in INTERMILES</div>
                          </td>

                          <td style="width: 70%">
                            <div class="intd2 fc">
                              Booking in INTERMILES + cash
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="dashtd">
                            <div class="intd1">{{ miles }}</div>
                          </td>

                          <td class="dashtd1">
                            <div class="intd1">{{ cash }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div class="div123"></div>
                          </td>

                          <td>
                            <div class="div123"></div>
                          </td>
                          <td>
                            <div class="div123"></div>
                          </td>
                        </tr>
                        <tr>
                          <td style="width: 40%">
                            <div class="intd1 fc">Total INTERMILES redeemed</div>
                          </td>
                          <td style="width: 32%">
                            <div class="intd2 fc">
                              Total INTERMILES + Cash redeemed
                            </div>
                          </td>
                          <td style="width: 20%">
                            <div class="intd2"></div>
                          </td>
                        </tr>

                        <tr>
                          <td class="dashtd">
                            <div class="intd1">{{ milesreedemed }}</div>
                          </td>
                          <td class="dashtd1">
                            <div class="intd1">{{ TotalmilesPlusCash }}</div>
                          </td>
                          <td class="dashtd1">
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <div class="div123"></div>
                          </td>

                          <td>
                            <div class="div123"></div>
                          </td>
                          <td>
                            <div class="div123"></div>
                          </td>
                        </tr>
                      </ng-container>
                      <tr>
                        <td style="width: 30%">
                          <div class="intd1 fc">Convenience Fee with GST</div>
                        </td>
                        <td style="width: 30%">
                          <div class="intd2 fc">
                            Convenience Fee without GST
                          </div>
                        </td>
                        <td style="width: 30%">
                          <div class="intd2"></div>
                        </td>
                      </tr>

                      <tr>
                        <td class="dashtd">
                          <div class="intd1">
                            {{ Con_Fee_with_gst.toFixed(2) }}
                          </div>
                        </td>
                        <td class="dashtd1">
                          <div class="intd1">
                            {{ Con_Fee_without_gst.toFixed(2) }}
                          </div>
                        </td>
                        <td class="dashtd1">
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <div class="div123"></div>
                        </td>

                        <td>
                          <div class="div123"></div>
                        </td>
                        <td>
                          <div class="div123"></div>
                        </td>
                      </tr>

                      <tr>
                        <td style="width: 20%">
                          <div class="intd1 fc">International</div>
                        </td>
                        <td style="width: 20%">
                          <div class="intd2 fc">Domestic</div>
                        </td>
                        <td style="width: 20%">
                          <div class="intd2">

                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="dashtd">
                          <div class="intd1">{{ international }}</div>
                        </td>
                        <td class="dashtd1">
                          <div class="intd1">{{ domestic }}</div>
                        </td>
                        <td class="dashtd1">

                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="clr"></div>
                  <div *ngIf="loader">
                    <div style="margin:auto; text-align: center">
                      <img
                        src="https://vignette.wikia.nocookie.net/lego/images/b/b4/Loading_Animation.gif/revision/latest/scale-to-width-down/480?cb=20120528032206"
                        width="8%" height="8%" alt="Loader" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>